import React, { useState, useEffect } from "react";
import {
  AppProvider,
  LegacyCard,
  TextField,
  Select,
  InlineGrid,
  ChoiceList,
  Icon,
  Checkbox,
} from "@shopify/polaris";
import en from "@shopify/polaris/locales/en.json";
import { useLocation, useNavigate } from "react-router-dom";
import { useLibrary } from "./LibraryContext";
import { ArrowLeftIcon } from "@shopify/polaris-icons";
import CustomAutocomplete from "./CustomAutocomplete";
import JacketForm from "./OrderFrom/MenJacketForm";
import PantForm from "./OrderFrom/MenPantForm";
import VestForm from "./OrderFrom/MenVestForm";
import ShortForm from "./OrderFrom/MenShortForm";
import DrawstringPant from "./OrderFrom/DrawstringPant";
import DrawstringShort from "./OrderFrom/DrawstringShort";
import MenBomber from "./OrderFrom/MenBomber";
import MenJean from "./OrderFrom/MenJeanForm";
import PartsOrderLabel from "./OrderFrom/PartsOrderLabelForm";
import PartsOrderCuff from "./OrderFrom/PartsOrderCuffForm";
import WomenJacket from "./OrderFrom/WomenJacketForm";
import MenOvercoat from "./OrderFrom/MenOvercoatForm";
import ShirtLongSleeve from "./OrderFrom/ShirtLongSleeveForm";
import ShirtShortSleeve from "./OrderFrom/ShirtShortSleeveForm";
import WomenPantForm from "./OrderFrom/WomenPantForm";
import WomenVestForm from "./OrderFrom/WomenVestForm";
import WomenShortForm from "./OrderFrom/WomenShortForm";
import WomenOvercoatForm from "./OrderFrom/WomenOvercoatForm";
import WomenJeanForm from "./OrderFrom/WomenJeanForm";
import WomenShirtLongSleeveForm from "./OrderFrom/WomenShirtLongSleeveForm";
import WomenShirtShortSleeveForm from "./OrderFrom/WomenShirtShortSleeveForm";
import JacketMeasurements from "./Customers/JacketMeasurements";
import PantMeasurements from "./Customers/PantMeasurements";
import ShortPantMeasurements from "./Customers/ShortPantMeasurements";
import VestMeasurements from "./Customers/VestMeasurements";
import ShirtMeasurements from "./Customers/ShirtMeasurements";
import JeanMeasurements from "./Customers/JeanMeasurements";
import MenOvercoatMeasurements from "./Customers/MenOvercoatMeasurements";
import WomenJacketMeasurements from './Customers/WomenJacketMeasurements';
import WomenPantMeasurements from './Customers/WomenPantMeasurements';
import WomenShortMeasurements from './Customers/WomenShortMeasurements';
import WomenVestMeasurements from './Customers/WomenVestMeasurements';
import WomenShirtMeasurements from './Customers/WomenShirtMeasurements';
import WomenOvercoatMeasurements from './Customers/WomenOvercoatMeasurements';
import WomenJeanMeasurements from './Customers/WomenJeanMeasurements';
import TshirtForm from "./OrderFrom/TshirtForm";
import PalmJacketMeasurements from './Customers/PalmJacketMeasurements';
import PalmJacketForm from "./OrderFrom/PalmJacketForm";
import PartsOrderCollarForm from "./OrderFrom/PartsOrderCollarForm";
import PocketSquareForm from "./OrderFrom/PocketSquareForm";


export default function OrderView() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const { fabrics: Fabrics, linings: LiningNumbers, tshirtFabrics: TshirtFabrics } = useLibrary();
  const location = useLocation();
  const OrderData = location.state?.orderData;
  const ReorderOld = OrderData.json;
  const customer_id = ReorderOld?.customer_id_row;

  const [form, setForm] = useState({});

  const [formCustomer, setformCustomer] = useState({
    measurements: {
      jacket: true,
      pant: false,
      shortPant: false,
      vest: false,
      shirt: false,
      jean: false,
      menOvercoat: false,
      womenJacket: false,
      womenPant: false,
      womenShort: false,
      womenVest: false,
      womenShirt: false,
      palmJacket: false,
      womenOvercoat: false,
      womenJean: false,
    },
    jacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
    pant: {
      waist: "",
      seat: "",
      outseam: "",
      knee: "",
      bottom: "",
    },
    shortPant: {
      waist: "",
      seat: "",
      shortOutseam: "",
      shortBottom: "",
    },
    vest: {
      chest: "",
      stomach: "",
      backLength: "",
      frontLength: ""
    },
    shirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirttHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
      shirtSleeveLenghtL: "",
      shirtSleeveLenghtR: "",
      shortSleeveCuff: "",
    },
    jean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outseam: "",
    },
    menOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
    },
    womenPant: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenShort: {
      waist: "",
      seat: "",
      uRise: "",
      outSeam: "",
      knee: "",
      bottom: "",
    },
    womenVest: {
      chest: "",
      stomach: "",
      backLength: "",
      firstButton: "",
    },
    womenShirt: {
      neck: "",
      chest: "",
      stomach: "",
      shirtHip: "",
      shoulder: "",
      shirtLength: "",
      sleeveL: "",
      sleeveR: "",
      cuffL: "",
      cuffR: "",
    },
    womenOvercoat: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      overcoatLength: "",
    },
    womenJean: {
      waist: "",
      seat: "",
      thigh: "",
      frontRise: "",
      backRise: "",
      knee: "",
      bottom: "",
      outSeam: "",
    },
    palmJacket: {
      chest: "",
      stomach: "",
      shoulder: "",
      sleeveL: "",
      sleeveR: "",
      jacketLength: "",
      firstButtonPlacement: "",
    },
  });

  useEffect(() => {
    if (ReorderOld) {
      setForm(ReorderOld);
    }
  }, [ReorderOld]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      return;
    }

    const fetchCustomer = async () => {
      try {
        const response = await fetch(
          `${baseUrl}/api/customers/${customer_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Customer not found");
        }

        const data = await response.json();
        setformCustomer(data?.json);
      } catch (err) {
      } finally {
      }
    };

    fetchCustomer();
  }, [customer_id, baseUrl]);

  const [errors, setErrors] = useState({});
  const [apploader, setApploader] = useState(false);
  const navigate = useNavigate();
  const itemtype = [
    "Men Suit",
    "Men 3pc Suit",
    "Men Shirt Long Sleeve",
    "Men Shirt Short Sleeve",
    "Men Jacket",
    "Men Pant",
    "Men Short",
    "Men Vest",
    "Men Bomber",
    "Men Overcoat",
    "Men Jean",
    "Drawstring Pant",
    "Drawstring Short",
    "Women Suit",
    "Women 3pc Suit",
    "Women Jacket",
    "Women Pant",
    "Women Vest",
    "Women Shirt Long Sleeve",
    "Women Shirt Short Sleeve",
    "Women Sleeveless Shirt",
    "Women Short",
    "Women Overcoat",
    "Women Jean",
    "Parts Order Label",
    "Parts Order Cuff",
    "Parts Order Collar",
    "T-Shirt & Polo",
    "The Palm Jacket",
    "Pocket Square",
  ];

  const handleBack = () => {
    navigate(-1);
  };

  const handleChange =
    (section, key = null) =>
      (values) => { };

  const conditionalFieldsMap = {
    menvest: {
      coveredButton: {
        conditionValue: "Satin Number",
        dependentKey: "coveredButtonSatin",
      },
      tuxedoWrap: {
        conditionValue: "Yes",
        dependentKey: "tuxedoWrapSatin",
      },
      backFabric: {
        conditionValue: "Lining Specify",
        dependentKey: "backFabricLining",
      },
      lapelContrast: {
        conditionValue: ["Lapel", "Lapel edge"],
        dependentKey: "lapelContrastLapel",
      },
    },
  };


  return (
    <AppProvider i18n={en}>
      <div className="re_order_view">
        <div className="button_option">
          <h2>
            <span onClick={handleBack}>
              <Icon source={ArrowLeftIcon} tone="base" />
            </span>
            Order Summary
          </h2>
        </div>
        <LegacyCard title="Customer Information" sectioned>
          <InlineGrid columns={{ xs: 1, sm: 3, md: 2, lg: 3 }} gap="400">
            <TextField
              label="Order ID"
              value={OrderData.orderId}
              placeholder="Order Id"
              readOnly
            />
            <TextField
              label="Full Name"
              value={ReorderOld?.customerName}
              placeholder="Full Name"
              readOnly
            />
            <TextField
              label="Customer ID"
              value={ReorderOld?.CustomerID}
              placeholder="Customer ID"
              readOnly
            />
          </InlineGrid>
        </LegacyCard>
        <LegacyCard title="Basic Information" sectioned>
          <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
            <Select
              label="Item Type"
              options={itemtype}
              value={form.Itemtype}
              disabled
            />
            {form.Itemtype !== "Pocket Square" && (
              <CustomAutocomplete
                label="Fabric Number"
                optionsList={form.Itemtype === "T-Shirt & Polo" ? TshirtFabrics : Fabrics}
                onChange={handleChange("FabricNumber")}
                defaultValue={form.FabricNumber}
              />
            )}
            <div className="two_culumn">
              <Select
                label="Date Needed"
                options={["Normal", "Event Date", "Urgent Rush"]}
                onChange={handleChange("DateNeeded")}
                value={form.DateNeeded}
              />
              {form.DateNeeded === "Event Date" ||
                form.DateNeeded === "Urgent Rush" ? (
                <TextField
                  label="Date"
                  value={form.NeededDate}
                  onChange={handleChange("NeededDate")}
                  error={errors.NeededDate}
                  placeholder="MM-DD-YYYY"
                />
              ) : null}
            </div>
          </InlineGrid>
        </LegacyCard>

        {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
          <div className="customer_body_option view-mode-readonly">
            <LegacyCard title="Body Notes" sectioned>
              <ChoiceList
                allowMultiple
                choices={[
                  { label: "Head Forward", value: "Head Forward" },
                  { label: "Left Shoulder Down", value: "Left Shoulder Down" },
                  { label: "Right Shoulder Down", value: "Right Shoulder Down" },
                  { label: "Left Shoulder Up", value: "Left Shoulder Up" },
                  { label: "Right Shoulder Up", value: "Right Shoulder Up" },
                  { label: "Humpback", value: "Humpback" },
                  { label: "Arms Forward", value: "Arms Forward" },
                  { label: "Arms Backward", value: "Arms Backward" },
                  { label: "Chest Out", value: "Chest Out" },
                  { label: "Stomach Out", value: "Stomach Out" },
                  { label: "Large Bicep", value: "Large Bicep" },
                  { label: "Large Calf", value: "Large Calf" },
                ]}
                selected={formCustomer?.bodyNotes || []}
                onChange={() => {}}
              />
            </LegacyCard>
          </div>
        )}

        {form?.Itemtype && !["Parts Order Label", "Parts Order Cuff", "Parts Order Collar", "Pocket Square"].includes(form?.Itemtype) && (
          <LegacyCard title="Measurements Updated" sectioned>
            <Checkbox
              label="Measurements Updated For This Order"
              checked={form.measurementsUpdated || false}
              onChange={() => {}}
              disabled
            />
          </LegacyCard>
        )}

        {["Men Suit", "Men 3pc Suit", "Men Jacket", "Men Bomber"].includes(form?.Itemtype) && (
          <JacketMeasurements
            values={formCustomer.jacket}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                jacket: { ...prev.jacket, [key]: value },
              }))
            }
          />
        )}

        {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
          <VestMeasurements
            values={formCustomer.vest}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                vest: { ...prev.vest, [key]: value },
              }))
            }
          />
        )}

        {["Men Suit", "Men 3pc Suit", "Men Pant", "Drawstring Pant"].includes(form?.Itemtype) && (
          <PantMeasurements
            values={formCustomer.pant}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                pant: { ...prev.pant, [key]: value },
              }))
            }
          />
        )}

        {["Men Short", "Drawstring Short", "Drawstring Pant"].includes(form?.Itemtype) && (
          <ShortPantMeasurements
            values={formCustomer.shortPant}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                shortPant: { ...prev.shortPant, [key]: value },
              }))
            }
          />
        )}


        {["Men Shirt Short Sleeve", "Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
          <ShirtMeasurements
            values={formCustomer.shirt}
            dataType={form.Itemtype}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                shirt: { ...prev.shirt, [key]: value },
              }))
            }
          />
        )}

        {["Men Jean"].includes(form?.Itemtype) && (
          <JeanMeasurements
            values={formCustomer.jean}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                jean: { ...prev.jean, [key]: value },
              }))
            }
          />
        )}

        {["Men Overcoat"].includes(form?.Itemtype) && (
          <MenOvercoatMeasurements
            values={formCustomer.menOvercoat}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                menOvercoat: { ...prev.menOvercoat, [key]: value },
              }))
            }
          />
        )}

        {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
          <WomenJacketMeasurements
            values={formCustomer.womenJacket}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenJacket: { ...prev.womenJacket, [key]: value },
              }))
            }
          />
        )}

        {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(form?.Itemtype) && (
          <WomenPantMeasurements
            values={formCustomer.womenPant}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenPant: { ...prev.womenPant, [key]: value },
              }))
            }
          />
        )}

        {["Women Short"].includes(form?.Itemtype) && (
          <WomenShortMeasurements
            values={formCustomer.womenShort}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenShort: { ...prev.womenShort, [key]: value },
              }))
            }
          />
        )}

        {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
          <WomenVestMeasurements
            values={formCustomer.womenVest}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenVest: { ...prev.womenVest, [key]: value },
              }))
            }
          />
        )}

        {["Women Shirt", "Women Shirt Short Sleeve", "Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
          <WomenShirtMeasurements
            values={formCustomer.womenShirt}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenShirt: { ...prev.womenShirt, [key]: value },
              }))
            }
          />
        )}

        {["Women Overcoat"].includes(form?.Itemtype) && (
          <WomenOvercoatMeasurements
            values={formCustomer.womenOvercoat}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenOvercoat: { ...prev.womenOvercoat, [key]: value },
              }))
            }
          />
        )}

        {["Women Jean"].includes(form?.Itemtype) && (
          <WomenJeanMeasurements
            values={formCustomer.womenJean}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                womenJean: { ...prev.womenJean, [key]: value },
              }))
            }
          />
        )}

        {["T-Shirt & Polo"].includes(form?.Itemtype) && (
          <ShirtMeasurements
            values={formCustomer.shirt}
            dataType="T-Shirt & Polo"
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                shirt: { ...prev.shirt, [key]: value },
              }))
            }
          />
        )}

        {["The Palm Jacket"].includes(form?.Itemtype) && (
          <PalmJacketMeasurements
            values={formCustomer.palmJacket}
            onChange={(key) => (value) =>
              setformCustomer((prev) => ({
                ...prev,
                palmJacket: { ...prev.palmJacket, [key]: value },
              }))
            }
          />
        )}

        {["Men Jacket", "Men Suit", "Men 3pc Suit"].includes(
          form?.Itemtype
        ) && (
            <JacketForm
              form={form}
              setForm={setForm}
              errors={errors}
              setErrors={setErrors}
              baseUrl={baseUrl}
              setApploader={setApploader}
              conditionalFieldsMap={conditionalFieldsMap}
              viewOrder="yes"
            />
          )}
        {["Men Vest", "Men 3pc Suit"].includes(form?.Itemtype) && (
          <VestForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Men Pant", "Men Suit", "Men 3pc Suit"].includes(form?.Itemtype) && (
          <PantForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}

        {["Men Short"].includes(form?.Itemtype) && (
          <ShortForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Women Short"].includes(form?.Itemtype) && (
          <WomenShortForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Drawstring Pant"].includes(form?.Itemtype) && (
          <DrawstringPant
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Drawstring Short"].includes(form?.Itemtype) && (
          <DrawstringShort
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Men Bomber"].includes(form?.Itemtype) && (
          <MenBomber
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Men Jean"].includes(form?.Itemtype) && (
          <MenJean
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Women Jean"].includes(form?.Itemtype) && (
          <WomenJeanForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}
        {["Parts Order Label"].includes(form?.Itemtype) && (
          <PartsOrderLabel
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Parts Order Cuff"].includes(form?.Itemtype) && (
          <PartsOrderCuff
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Parts Order Collar"].includes(form?.Itemtype) && (
          <PartsOrderCollarForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
          />
        )}
        {["Pocket Square"].includes(form?.Itemtype) && (
          <PocketSquareForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
          />
        )}
        {["T-Shirt & Polo"].includes(form?.Itemtype) && (
          <TshirtForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            viewOrder="yes"
          />
        )}
        {["The Palm Jacket"].includes(form?.Itemtype) && (
          <PalmJacketForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
          />
        )}
        {["Women Jacket", "Women Suit", "Women 3pc Suit"].includes(
          form?.Itemtype
        ) && (
            <WomenJacket
              form={form}
              setForm={setForm}
              errors={errors}
              setErrors={setErrors}
              baseUrl={baseUrl}
              setApploader={setApploader}
              conditionalFieldsMap={conditionalFieldsMap}
              viewOrder="yes"
            />
          )}
        {["Women Pant", "Women Suit", "Women 3pc Suit"].includes(
          form?.Itemtype
        ) && (
            <WomenPantForm
              form={form}
              setForm={setForm}
              errors={errors}
              setErrors={setErrors}
              baseUrl={baseUrl}
              setApploader={setApploader}
              conditionalFieldsMap={conditionalFieldsMap}
            />
          )}
        {["Women Vest", "Women 3pc Suit"].includes(form?.Itemtype) && (
          <WomenVestForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
          />
        )}

        {["Men Overcoat"].includes(form?.Itemtype) && (
          <MenOvercoat
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Women Overcoat"].includes(form?.Itemtype) && (
          <WomenOvercoatForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Men Shirt Long Sleeve"].includes(form?.Itemtype) && (
          <ShirtLongSleeve
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Women Shirt Long Sleeve"].includes(form?.Itemtype) && (
          <WomenShirtLongSleeveForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Men Shirt Short Sleeve"].includes(form?.Itemtype) && (
          <ShirtShortSleeve
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        {["Women Shirt Short Sleeve"].includes(form?.Itemtype) && (
          <WomenShirtShortSleeveForm
            form={form}
            setForm={setForm}
            errors={errors}
            setErrors={setErrors}
            baseUrl={baseUrl}
            setApploader={setApploader}
            conditionalFieldsMap={conditionalFieldsMap}
            viewOrder="yes"
          />
        )}
        <LegacyCard title="Order Status" sectioned>
          <ChoiceList
            choices={[
              { label: "Draft", value: "Draft" },
              { label: "Submitted", value: "Submitted" },
              { label: "Production", value: "Production" },
              { label: "Shipping", value: "Shipping" },
              { label: "Delivered", value: "Delivered" },
            ]}
            selected={[OrderData?.orderStatus]}
            onChange={(value) => setForm({ ...form, orderStatus: value[0] })}
          />
        </LegacyCard>
        <LegacyCard title="Quantity" sectioned>
          <InlineGrid columns={{ xs: 1, sm: 2, md: 2, lg: 3 }} gap="400">
            <TextField
              label=""
              value={form.Qty || "1"}
              readOnly
            />
          </InlineGrid>
        </LegacyCard>
        <LegacyCard title="NOTES" sectioned>
          <InlineGrid columns={1} gap="300">
            <div className="order_notes">
              <TextField
                value={form.orderNotes}
                onChange={handleChange("orderNotes")}
                error={errors.orderNotes}
                placeholder="Add your notes here..."
              />
            </div>
          </InlineGrid>
        </LegacyCard>
        <div className="customerAddBtn"></div>
      </div>
    </AppProvider>
  );
}
